import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../../../../services/common/common-field.service";
import {AllocationRequest} from "../../../../../../model/clearing/allocation/allocation-request";
import {ClearingAllocationService} from "../../../../../../services/clearing/clearing-allocation.service";
import {SplitAllocationFormBaseComponent} from "../split-allocation-form-base.component";
import {Order} from "../../../../../../model/clearing/order";
import {ExchangeContractService} from "../../../../../../services/exchange/exchange-contract.service";
import {ThemeService} from "../../../../../../services/tools/theme.service";
import {ClearingInfoLoadRequest} from "../../../../../../model/clearing/clearing-info-load-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../../../model/api/api-validation";
import {ClearingSelectionSummary} from "../../../../../../model/clearing/clearing-selection-summary";
import {ClearingOrderInfoService} from "../../../../../../services/clearing/clearing-order-info.service";
import {AppConfigService} from "../../../../../../services/app-config.service";
import {CookieService} from "ngx-cookie-service";
import {FieldsService} from "../../../../../../services/common/fields-service";
import {CcStorageService} from "../../../../../../services/common/cc-storage.service";

@Component({
  selector: 'app-clearing-update-split-allocation-form',
  templateUrl: './update-split-allocation-form.component.html',
  styleUrls: ['../split-allocation-form-base.component.scss', '../allocation-form-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateSplitAllocationFormComponent extends SplitAllocationFormBaseComponent {

  significantOrders: Order[] = []

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              allocationService: ClearingAllocationService,
              exchangeContractService: ExchangeContractService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              themeService: ThemeService,
              private clearingOrderInfoService: ClearingOrderInfoService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref,
      allocationService,
      exchangeContractService,
      commonFieldService,
      appConfigService,
      messageService,
      confirmationService,
      translateService,
      themeService,
      storageService,
      fieldsService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.update_split_allocation');
  }

  public open(selectedIds: string[], orders: Order[], allocationInProgress: AllocationRequest = undefined): void {
    if (selectedIds && selectedIds.length > 0) {
      this.loadingProgressValue = 0;
      // this.allocationService.getSignificantOrders(selectedIds, true).subscribe(validation => {
      //   if (validation.success) {
      //     const significantOrdersInfo: SignificantOrdersInfo = validation.item;
      this.significantOrders = orders;
      this.formContractsCodes = [...new Set(this.significantOrders.map(value => value.contractCode))];
      if (!allocationInProgress) {
        allocationInProgress = new AllocationRequest();
        allocationInProgress.orderIds = selectedIds; // need tests

        const firstOrder = this.significantOrders[0];
        allocationInProgress.owner = firstOrder.owner;
        allocationInProgress.clearingHouse = firstOrder.clearingHouse;
        allocationInProgress.exchangeCode = firstOrder.exchangeCode;
        allocationInProgress.accountTypeCode = firstOrder.account ? firstOrder.account.type : undefined;
        allocationInProgress.contractCode = firstOrder.contractCode;
        allocationInProgress.clearingDate = firstOrder.clearingDate;
        allocationInProgress.businessDate = firstOrder.businessDate;
        allocationInProgress.creationDate = firstOrder.creationDate;
        allocationInProgress.contractUnit = firstOrder.contractUnit;
        allocationInProgress.contractVersion = firstOrder.contractVersion;
        // allocationInProgress.owner = firstOrder.owner;
        // allocationInProgress.customerName = firstOrder.customerName;
        // allocationInProgress.reference1 = firstOrder.account.reference1;
        // allocationInProgress.reference2 = firstOrder.account.reference2;
        // allocationInProgress.executionFee = firstOrder.executionFee;
        // allocationInProgress.giveUpCommission = firstOrder.giveUpCommission;
        // allocationInProgress.currency = firstOrder.brokerageCurrency;
        // allocationInProgress.accountCode = firstOrder.account.name;
        allocationInProgress.orderReference = firstOrder.reference;
        // allocationInProgress.giveupAccountType = firstOrder.giveUpAccountType;
        // allocationInProgress.giveUpBrokerCode = firstOrder.giveUpBrokerCode;
        // allocationInProgress.giveUpMessage = firstOrder.giveUpMessage;
        // allocationInProgress.giveUpMessage2 = firstOrder.giveUpMessage2;
        allocationInProgress.maturity = firstOrder.maturity;
        allocationInProgress.callPut = firstOrder.callPut;
        allocationInProgress.openClose = firstOrder.openClose;
        // allocationInProgress.apsGroupId = firstOrder.avgPriceGroupId;
        // allocationInProgress.apsPrice = firstOrder.avgPriceResidual;
        allocationInProgress.apsPrice = firstOrder.avgPrice;
        allocationInProgress.apsRoundPrice = firstOrder.avgRndPrice;
        allocationInProgress.overrideApsPrice = firstOrder.overrideAvgPrice;
        // allocationInProgress.openClose = firstOrder.openClose;
        // allocationInProgress.openClose = firstOrder.openClose;
        // allocationInProgress.volume = firstOrder.volume;
        // allocationInProgress.traderName = firstOrder.trader;
        // allocationInProgress.reference3 = firstOrder.account.reference3;
        // allocationInProgress.brokerageRuleType = firstOrder.brokerageRule;
        // allocationInProgress.giveUpMessage3 = firstOrder.giveUpMessage3;
        allocationInProgress.tradeType = firstOrder.tradeType;
        allocationInProgress.tradingEnvironment = firstOrder.tradingEnvironment;
        allocationInProgress.strike = firstOrder.strike;
        allocationInProgress.side = firstOrder.side;
        allocationInProgress.desk = firstOrder.desk;
        allocationInProgress.customOrderReference = firstOrder.customOrderReference;
        allocationInProgress.traderMemo = firstOrder.freeText2;
        allocationInProgress.apsGroupId = firstOrder.avgPriceGroupId;
        allocationInProgress.orderIds = [];
        allocationInProgress.tradeIds = [];

        allocationInProgress.volume = 0;
        allocationInProgress.price = 0;
        this.significantOrders.forEach(order => {
          let allocationSplit = allocationInProgress.allocations.find(allocSplit => allocSplit.clearingHouse == order.clearingHouse
            && allocSplit.apsGroupId == order.avgPriceGroupId
            && allocSplit.exchangeCode == order.exchangeCode
            && allocSplit.accountCode == (order.account ? order.account.name : undefined)
            && allocSplit.accountTypeCode == (order.account ? order.account.type : undefined)
            && allocSplit.reference1 == (order.account ? order.account.reference1 : undefined)
            && allocSplit.reference2 == (order.account ? order.account.reference2 : undefined)
            && allocSplit.reference3 == (order.account ? order.account.reference3 : undefined)
            && allocSplit.giveUpBrokerCode == order.giveUpBrokerCode
            && allocSplit.giveUpMessage == order.giveUpMessage
            && allocSplit.giveUpMessage2 == order.giveUpMessage2
            && allocSplit.giveUpMessage3 == order.giveUpMessage3
            && allocSplit.state == (order.clearingInfo ? order.clearingInfo.displayState : undefined)
          )
          if (!allocationSplit) {
            allocationSplit = {
              clearingHouse: order.clearingHouse,
              exchangeCode: order.exchangeCode,
              state: order.clearingInfo ? order.clearingInfo.displayState : undefined,
              allocation: order.volume,
              residual: order.avgPriceResidual,
              traderName: order.trader,
              apsGroupId: order.avgPriceGroupId,
              openClose: order.openClose,
              giveupAccountType: order.giveUpAccountType,
              giveUpBrokerCode: order.giveUpBrokerCode,
              giveUpMessage: order.giveUpMessage,
              giveUpMessage2: order.giveUpMessage2,
              giveUpMessage3: order.giveUpMessage3,
              broker: order.broker,
              execTrader: order.submittingTrader,
              customerName: order.customerName,
              reference1: (order.account ? order.account.reference1 : undefined),
              reference2: (order.account ? order.account.reference2 : undefined),
              reference3: (order.account ? order.account.reference3 : undefined),
              executionFee: order.executionFee,
              giveUpCommission: order.giveUpCommission,
              rate: order.brokerageRateAmount,
              currency: order.brokerageCurrency,
              accountCode: (order.account ? order.account.name : undefined),
              accountTypeCode: (order.account ? order.account.type : undefined),
              overrideApsPrice: order.overrideAvgPrice,
              moneyOwner: order.clearingBroker,
            };
            allocationInProgress.allocations.push(allocationSplit);
          } else {
            allocationSplit.allocation += order.volume;
          }
          allocationInProgress.volume += order.volume;
          allocationInProgress.price += order.price * order.volume;
          allocationInProgress.orderIds.push(order.id);
          allocationInProgress.tradeIds.push(...order.clearings.map(value => value.tradeId));
        });
        allocationInProgress.price = allocationInProgress.price / allocationInProgress.volume;

      }

      // try
      // {
      //   if (!string.IsNullOrEmpty(_view.ApsPrice))
      //   {
      //     allocationRequest.apsPrice = ParsingUtils.ParseDoubleWithUiCulture(_view.ApsPrice);
      //   }
      //   else
      //   {
      //     allocationRequest.apsPrice = 0;
      //   }
      // }
      // catch (FormatException fe)
      // {
      //   isValid = false;
      //   CrystalLog.LogError(string.Format("FormatException : ApsPrice value {0} is not a number", _view.ApsPrice));
      //   CrystalLog.LogDebug(string.Format("AllocationPresenter - Cannot parse avgPrice value : {0}", fe.Message));
      // }
      // try
      // {
      //   if (!string.IsNullOrEmpty(_view.ApsRoundedPrice))
      //   {
      //     allocationRequest.apsRoundPrice = ParsingUtils.ParseDoubleWithUiCulture(_view.ApsRoundedPrice);
      //   }
      //   else
      //   {
      //     allocationRequest.apsRoundPrice = 0;
      //   }
      // }
      // catch (FormatException fe)
      // {
      //   isValid = false;
      //   CrystalLog.LogError(string.Format("FormatException : ApsRoundedPrice value {0} is not a number", _view.ApsRoundedPrice));
      //   CrystalLog.LogDebug(string.Format("AllocationPresenter - Cannot parse avgRndPrice value : {0}", fe.Message));
      // }

      // try
      // {
      //   if (!string.IsNullOrEmpty(_view.ApsOverride))
      //   {
      //     allocationRequest.apsOverridePrice = ParsingUtils.ParseDoubleWithUiCulture(_view.ApsOverride);
      //   }
      //   else
      //   {
      //     allocationRequest.apsOverridePrice = 0;
      //   }
      // }
      // catch (FormatException fe)
      // {
      //   isValid = false;
      //   CrystalLog.LogError(string.Format("FormatException : ApsOverride value {0} is not a number", _view.ApsOverride));
      //   CrystalLog.LogDebug(string.Format("AllocationPresenter - Cannot parse overrideAvgPrice value : {0}", fe.Message));
      // }
      this.formRecord = allocationInProgress;
      this.loadData();
      // this.filterExchanges();
      // this.filterTradingEnvs();
      // this.filterCustomers();
      // this.filterAccountTypes();
      // this.filterContracts();
      // setTimeout(()=>this.ccFormDialog.reloadFieldValueMap(), 250);

      this.loadFooterInfos(this.formRecord.orderIds);
      this.show();
      // } else {
      //   this.errorMessage(validation.message);
      // }
      // });
    }
  }

  // public open(selectedIds: string[], clearingSelectionInfos: ClearingSelectionInfo[]): void {
  //   if (selectedIds && selectedIds.length > 0) {
  //     this.allocationService.getSignificantTrades(selectedIds).subscribe(validation => {
  //       if (validation.success) {
  //         const allocationInProgress = new AllocationRequest();
  //         allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
  //         allocationInProgress.tradeIds = selectedIds;
  //         const firstTrade = validation.item[0];
  //         // allocationInProgress.owner = firstTrade.owner;
  //         allocationInProgress.businessDate = firstTrade.businessDate;
  //         allocationInProgress.clearingDate = firstTrade.clearingDate;
  //         allocationInProgress.clearingHouse = firstTrade.clearingHouse;
  //         allocationInProgress.exchangeCode = firstTrade.exchangeCode;
  //         allocationInProgress.side = firstTrade.side;
  //         allocationInProgress.contractCode = firstTrade.contractCode;
  //         allocationInProgress.contractUnit = firstTrade.contractUnit;
  //         allocationInProgress.contractVersion = firstTrade.contractVersion;
  //         allocationInProgress.tradingEnvironment = firstTrade.tradingEnvironment;
  //         allocationInProgress.maturity = firstTrade.maturity;
  //         allocationInProgress.owner = firstTrade.owner;
  //         allocationInProgress.volume = clearingSelectionInfos[0].totalVolume
  //         // clearingSelectionInfos.reduce((accumulator, clearingSelectionInfo) => {
  //         //   return accumulator + clearingSelectionInfo.totalVolume;
  //         // }, 0);
  //         allocationInProgress.callPut = firstTrade.callPut;
  //         allocationInProgress.strike = firstTrade.strike;
  //         allocationInProgress.customOrderReference = firstTrade.customOrderReference;
  //         // this.contracts = [{text:firstTrade.contractCode, id:allocationInProgress.contractId, value: undefined}];
  //         // console.log("------> allocationInProgress " + JSON.stringify(allocationInProgress));
  //         const allocationSplit: AllocationSplitRequest = {
  //           allocation: allocationInProgress.volume,
  //         };
  //         allocationInProgress.allocations.push(allocationSplit);
  //         this.openWithRecord(allocationInProgress);
  //       } else {
  //         this.errorMessage(validation.message);
  //         this.loadingProgressValue = 100;
  //       }
  //     });
  //   }
  // }

  public openWithRecord(newFormRecord: AllocationRequest): void {
    this.formRecord = newFormRecord;
    this.filterTradingEnvs();
    this.filterCustomers();
    this.filterAccountTypes();
    // this.filterContracts();
    this.show();
  }

  protected doSave() {
    this.formLoading = true;
    this.formRecord.allocations.forEach(alloc => {
      if (this.manageGiveUpMssg23()) {
        alloc.broker = alloc.giveUpMessage3;
      }
    });
    this.allocationService.splitAllocationRequest(this.formRecord).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  protected getSelectionSummary(summaryRequest: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.clearingOrderInfoService.getSelectionSummary(summaryRequest);
  }

}
